import { lazyLoad } from 'utils/loadable';

export const ForbiddenPage = lazyLoad(
  () => import('./ForbiddenPage'),
  module => module.default,
);
